<script>

	export default {

	  inserted: (el, props) => {
			/* <div v-scroll-to="{target: '.something', subtract: boolean}">CLICK HERE</div> */
  		const target = props.value.target
			const page = $("html, body")


			$(el).bind('click', () => scroll())

			if(target === '.on-load-scroll')  {
				setTimeout(function(){ 
					$(el).trigger('click', () => scroll())
				}, 100);

			}

			const scroll = () => {
				const actions = "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove"
					if(props.value.subtract == true) {
						const navHeight = $(".main-nav").outerHeight();
						const breadCrumbHeight = $('.community-nav') ? $('.community-nav').outerHeight() : 0;
						let totalSubtract = navHeight + breadCrumbHeight;
						var elemTop = $(target).offset().top - totalSubtract + 'px';
						
					} else {
						var elemTop = $(target).offset().top;
					}
					page.on(actions, () => page.stop())
					page.animate({ scrollTop: elemTop }, 600, 'swing', () => page.off(actions))

					return false; 
				}

	  		}

	}

</script>